var app_tv_ranker_table = $('#local-airing-views-table');

if (app_tv_ranker_table.length) {
    var saved_table_data = [];
    var unsaved_table_data = [];

    var saved_table;
    var unsaved_table;

    $(document).ready(function () {
        localAiringTable();
    });

    var localAiringTable = function(){
        saved_table_data = [];
        unsaved_table_data = [];
        $.ajax({
            type: "GET",
            url: '/ratings/comscore/local_airing_views/list/saved',
            dataType: 'json',
            success: function (data) {
                $.each(data['data'], function(index, value){
                    push = {
                        'order': value['updated_at'],
                        'name': value['name'],
                        'slug': value['slug'],
                        'created_at': value['updated_at']
                    };

                    saved_table_data.push(push);
                });

                if (saved_table instanceof $.fn.dataTable.Api) {
                    var table = $('#local-airing-views-saved').DataTable();

                    table.clear();
                    table.rows.add(saved_table_data);
                    table.draw();
                } else {
                    saved_table = $('#local-airing-views-saved').DataTable({
                        data: saved_table_data,
                        columns: [
                            {data:'order'},
                            {data: 'name'},
                            {data: 'created_at'},
                            {data: 'slug'}
                        ],
                        order: [ 0, "desc" ],
                        destroy: true,
                        "columnDefs": [
                            {
                                "targets": 0,
                                "visible": false,
                                "searchable": false,
                            },
                            {
                                "targets": 3,
                                "orderable": false,
                                "createdCell": function (td, cellData, rowData, row, col) {
                                    console.log('-----');
                                    console.log(cellData);
                                    var html = '<div class="row text-center"><div class="btn-group" role="group">' +
                                        '<a href="/ratings/comscore/airing/views/view/' +
                                        cellData +
                                        '" role="button" class="btn btn-info btn-sm">' +
                                        '<i class="fa fa-eye"></i> View' +
                                        '</a>' +
                                        '<a href="/ratings/comscore/airing/views/edit/' + cellData +' "  class="btn btn-success btn-sm btn-disabled edit-report " role="button">' +
                                        '<i class="fa fa-pencil"></i> Edit' +
                                        '</a>' +
                                        '</div>' +
                                        '<a href="javascript:void(0)" class="btn btn-danger btn-sm btn-disabled delete-report" data-slug="' + cellData + '" role="button">' +
                                        '<i class="fa fa-trash-o"></i> Delete' +
                                        '</a></div>';
                                    $(td).html(html);
                                }
                            }],
                        "drawCallback": function( settings ) {
                            $('.delete-report').unbind('click').bind('click', function(){
                                deleteLocalAiringViewsRpt($(this).attr('data-slug'));
                            });
                        }
                    });
                }

            }
        });

        $.ajax({
            type: "GET",
            url: '/ratings/comscore/local_airing_views/list/temp',
            dataType: 'json',
            success: function (data) {
                $.each(data['data'], function(index, value){
                    push = {
                        'order': value['updated_at'],
                        'name': value['name'],
                        'slug': value['slug'],
                        'created_at': value['updated_at']
                    };

                    unsaved_table_data.push(push);
                });

                if (unsaved_table instanceof $.fn.dataTable.Api) {
                    var table = $('#local-airing-views-temp').DataTable();

                    table.clear();
                    table.rows.add(unsaved_table_data);
                    table.draw();
                } else {
                    unsaved_table = $('#local-airing-views-temp').DataTable({
                        data: unsaved_table_data,
                        columns: [
                            {data:'order'},
                            {data: 'name'},
                            {data: 'created_at'},
                            {data: 'slug'}
                        ],
                        order: [ 0, "desc" ],
                        destroy: true,
                        "columnDefs": [
                            {
                                "targets": 0,
                                "visible": false,
                                "searchable": false,
                            },
                            {
                                "targets": 3,
                                "orderable": false,
                                "createdCell": function (td, cellData, rowData, row, col) {
                                    var html = '<div class="row text-center"><div class="btn-group" role="group">' +
                                        '<a href="/ratings/comscore/airing/views/view/' +
                                        cellData +
                                        '" role="button" class="btn btn-info btn-sm">' +
                                        '<i class="fa fa-eye"></i> View' +
                                        '</a>' +
                                        '</div>' +
                                        '<a href="javascript:void(0)" class="btn btn-danger btn-sm btn-disabled delete-report" data-slug="' + cellData + '" role="button">' +
                                        '<i class="fa fa-trash-o"></i> Delete' +
                                        '</a></div>';
                                    $(td).html(html);
                                }
                            }],
                        "drawCallback": function( settings ) {
                            $('.delete-report').unbind('click').bind('click', function(){
                                deleteLocalAiringViewsRpt($(this).attr('data-slug'));
                            });
                        }
                    });
                }
            }
        });
    };

    var deleteLocalAiringViewsRpt = function(slug) {
        var urlVar = '/ratings/comscore/local_airing_views/delete/' + slug;
        swal({
                title: "Are you sure you want to delete?",
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    show_loader();
                    $.ajax({
                        url: urlVar,
                        success: function (response) {
                            global_notification('success', 'Report deleted.');
                            localAiringTable();
                            hide_loader();
                        },
                        error: function (xhr) {
                            ajax_error();
                            debug(xhr.responseText);
                            localAiringTable();
                        }
                    });
                }
            });
    }
}

if($('#local_airing_views_div_table').length){
    console.log(req, result)

    var cellRenderNumber = function (params) {
        return '<div style="text-align: right;">' + ((!isNaN(params.value) && params.value !== null) ? params.value : (typeof params.value !== "undefined") ? 0 : "") + '</div>'
    }
    var cellRenderText = function (params) {
        return '<div style="text-align: left;">' + ((typeof params.value !== "undefined" && params.value !== null) ? params.value : "") + '</div>'
    }

    var columnDefs = [
        {headerName: "Daypart", field: "daypart", minWidth: 100, width: 220,pinned: "left",rowGroupIndex: 0, hide: true},
        {headerName: "Num. Hours", field: "num_hours",filter: 'number',cellRenderer: cellRenderNumber},
        {headerName: "Avg. Aud.", field: "avg_aud",filter: 'number',cellRenderer: cellRenderNumber},
        {headerName: "Num. Airings", field: "num_airings",filter: 'number',cellRenderer: cellRenderNumber},
        {headerName: "Rating", field: "rating",filter: 'number',cellRenderer: cellRenderNumber},
        {headerName: "Share", field: "share",filter: 'number',cellRenderer: cellRenderNumber},
        {headerName: "Station Callsign", field: "station_call_sign",cellRenderer: cellRenderText},
        {headerName: "Station No.", field: "station_no",filter: 'number',cellRenderer: cellRenderNumber},
        {headerName: "Series", field: "series_name_or_various",cellRenderer: cellRenderText},
        {headerName: "Series No.", field: "series_no",filter: 'number',cellRenderer: cellRenderNumber},
        {headerName: "Demo " + req['primary_demo_type'].toUpperCase() + " " + req['seldemo'].toUpperCase() + " Rating", field: "demo_ratings",filter: 'number',cellRenderer: cellRenderNumber},
        {headerName: "Demo " + req['primary_demo_type'].toUpperCase() + " " + req['seldemo'].toUpperCase() + " Share", field: "demo_share",filter: 'number',cellRenderer: cellRenderNumber},
    ];
    if(req['rpt_sort_by'].length > 0 && req['rpt_sort_by'][0] !== "")
        columnDefs[columnDefs.findIndex(elem => req['rpt_sort_by'].indexOf(elem.field) !== -1)]['sort'] = "asc";
    // specify the data
    var rowData = [];
    var data_available = false
    for(var i in result){
        console.log(i,result[i])
        for(var j in result[i]['result_rows']){
            rowData.push({
                daypart: i,
                num_hours: result[i]['result_rows'][j][0],
                avg_aud: result[i]['result_rows'][j][1],
                num_airings: result[i]['result_rows'][j][4],
                rating: result[i]['result_rows'][j][5],
                share: result[i]['result_rows'][j][6],
                station_call_sign: result[i]['result_rows'][j][7],
                station_no: result[i]['result_rows'][j][8],
                series_name_or_various: result[i]['result_rows'][j][9],
                series_no: result[i]['result_rows'][j][10],
                demo_ratings: result[i]['result_rows'][j][11],
                demo_share: result[i]['result_rows'][j][12]})
            data_available = true
        }
    }

    if(!data_available){
        setTimeout(function () {
            swal({
                    title: "There is not data for the generated report fields.",
                    text: "",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "Close",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        },1000)
    }

    // let the grid know which columns and what data to use
    var gridOptions = {
        columnDefs: columnDefs,
        rowData: rowData,
        enableColResize: true,
        headerHeight: 30,
        rowHeight: 20,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },
        defaultColDef: {
            width: 140,
            suppressToolPanel: true
        },
        suppressContextMenu:true,
        groupColumnDef: {
            cellRenderer: 'agGroupCellRenderer',
            headerName: 'Daypart',
            pinned: 'left',
            width: 250,
            max_width: 300
        },
    };

    var eGridDiv = document.querySelector('#local_airing_views_div_table');
    $(document).ready(function () {
        new agGrid.Grid(eGridDiv, gridOptions);
    });

    function expExcel() {
        console.log(gridOptions)
        var columns_to_export=[];
        var col_state=gridOptions.columnApi.getColumnState();
        for(var i in col_state){
            if(col_state[i].hide==false)
                columns_to_export.push(col_state[i].colId)
        }
        var params = {
            skipHeader: false,
            columnGroups: true,
            skipFooters: false,
            skipGroups: false,
            skipPinnedTop: false,
            skipPinnedBottom: false,
            // allColumns: true,
            columnKeys: columns_to_export,
            onlySelected: false,
            suppressQuotes: false,
            fileName: "comscore_local_airing_views_report.xls",
            suppressTextAsCDATA: true,
        };
        params.processCellCallback = function (params) {
            var values_numbers = ["num_hours","avg_aud","num_airings","rating","share","station_no","series_no","demo_ratings","demo_share"]
            if(values_numbers.indexOf(params.column.colId) !== -1 && (isNaN(params.value) || params.value === null || params.value === ""))
                return 0
            else return params.value
        };

        params.customFooter = [
            ["\nLegal Disclaimer:\n"],
            ["All metrics contained in this document are calculations of GaleForce Digital Technologies and have not been verified by Comscore."],
        ];

        gridOptions.api.exportDataAsCsv(params);
        // var content = gridOptions.api.getDataAsExcel(params);
        // var workbook = XLSX.read(content, {type: 'binary'});
        // var xlsxContent = XLSX.writeFile(workbook, 'comscore-national-airing-views-report.xlsx', {bookType: 'xlsx', type: 'base64'});
    }
}